import { render, staticRenderFns } from "./TopicButton.vue?vue&type=template&id=73a0716f&scoped=true&"
import script from "./TopicButton.vue?vue&type=script&lang=js&"
export * from "./TopicButton.vue?vue&type=script&lang=js&"
import style0 from "./TopicButton.vue?vue&type=style&index=0&id=73a0716f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a0716f",
  null
  
)

export default component.exports